import Splash from './pages/Splash'
import Intro from './pages/Intro'
import IntroImage from './pages/IntroImage'
import InfoScreen from './pages/InfoScreen'
import Question from './pages/Question'
import Game from './pages/Game'
import Overview from './pages/Overview'
import Timeline from './pages/Timeline'
import Congrats from './pages/Congrats'
import verdictScreen from './pages/verdictScreen'

const routes = [
    { path: '/', component: Intro, meta: { scrollTop: 0 }},
    // { path: '/intro', component: Intro, meta: { scrollTop: 50 }},
    { path: '/introimage', component: IntroImage, meta: { scrollTop: 10 }},
    { path: '/infoscreen', component: InfoScreen, meta: { scrollTop: 0 }},
    { path: '/vraag', component: Question, meta: { scrollTop: 0 }},
    { path: '/spel', component: Game, meta: { scrollTop: 0 }},
    { path: '/overzicht', component: Overview, meta: { scrollTop: 0 }},
    { path: '/tijdlijn', component: Timeline, meta: { scrollTop: 0 }},
    { path: '/gefeliciteerd', component: Congrats, meta: { scrollTop: 0 }},
    { path: '/uitspraak', component: verdictScreen, meta: { scrollTop: 0 }},
    { path: '*', component: Intro, meta: { scrollTop: 0 }},
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js